module.exports = __webpack_public_path__ + "static/media/22.8b1474ce.mp3";